import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';
import { UserFeedbackPageComponent } from '../pages/cms/user-feedback/user-feedback-page.component';

@Injectable({
  providedIn: 'root',
})
export class MessagesFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<UserFeedbackPageComponent>
{
  canDeactivate(
    component: UserFeedbackPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(component.hasChanges, nextState.url);
  }
}
